module.exports = __webpack_public_path__ + "img/0010.f6394b28.png";